<template>
  <div id="app" :class="'route-'+$route.name">
    <router-view class="currentsite" name="currentsite"></router-view>
    <modal></modal>
    <router-view class="navigation" name="navigation"></router-view>
	<transition name="fade">
		<router-view class="mainview" id="page-wrap"></router-view>
	</transition>
  </div>
</template>

<script>
import modal from './components/Modal.vue'

export default {
  name: 'app',
  components:{
    modal
  }
  
  
}
</script>

